<template lang="pug">
v-row
	v-col(cols="12" sm="6" md="4" v-for="webcam in items" v-if="webcam.preview" :key="webcam.id")
		v-card(tile flat)
			nuxt-link(:to="localePath({name:'webcams-webcam', params: {webcam: webcam.id}})")
				v-img.pip(:src="webcam.preview" :aspect-ratio="16/9")
				div {{webcam.name}}
				span.grey--text - {{webcam.elevation}}m

</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: null
		}
	}
};
</script>
